var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30",class:_vm.cardClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }